import React, { useState, useEffect } from "react";
import styles from "./SyncModal.module.css";
import CheckBoxItem from "DreamStream/Shared/CheckBoxItem";
import Button from "shared/Button";

/**
 *
 * Simple Modal UI for Syncing Diamonds
 *
 */
export function SyncModal({ diamonds, onSubmit, onClose }) {
  const [_diamonds, setDiamonds] = useState(null);

  useEffect(() => {
    diamonds &&
      diamonds.data &&
      diamonds.data.length > 0 &&
      setDiamonds(
        diamonds.data.map((diamond) => {
          return {
            fullName: diamond.fullName,
            iboNumber: diamond.iboNumber,
            isChecked: false,
          };
        })
      );
  }, [diamonds]);

  const onSelectAll = () => {
    var diamondsClone = JSON.parse(JSON.stringify(_diamonds));
    diamondsClone.map((diamond) => (diamond.isChecked = true));
    setDiamonds(diamondsClone);
  };

  const onUnselectAll = () => {
    var diamondsClone = JSON.parse(JSON.stringify(_diamonds));
    diamondsClone.map((diamond) => (diamond.isChecked = false));
    setDiamonds(diamondsClone);
  };

  const handleCheck = (iboNumber) => {
    var diamondsClone = JSON.parse(JSON.stringify(_diamonds));
    var index = diamondsClone.findIndex(
      (diamond) => diamond.iboNumber === iboNumber
    );
    diamondsClone[index].isChecked = !diamondsClone[index].isChecked;
    setDiamonds(diamondsClone);
  };

  // function to format names
  const formatName = (name) => {
    var _name = name.split(",");
    if (_name[0]) {
      _name[0] = _name[0].trim().toLowerCase();
      _name[0] = _name[0].trim().charAt(0).toUpperCase() + _name[0].slice(1);
    }
    if (_name[1]) {
      _name[1] = _name[1].trim().toLowerCase();
      _name[1] = _name[1].trim().charAt(0).toUpperCase() + _name[1].slice(1);
    }
    return `${_name[0]}, ${_name[1]}`;
  };

  // return array of iboNumbers (if any)
  const handleSubmit = async () => {
    const checkedDiamonds = _diamonds.filter((diamond) => diamond.isChecked);
    if (checkedDiamonds.length > 0) {
      const retArray = checkedDiamonds.map((diamond) => diamond.iboNumber);
      await onSubmit(retArray);
      onClose();
    } else {
      alert("Please select diamonds before syncing");
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.header}>
          Select Diamonds
          <div className={styles.buttonContainer}>
            <Button
              className={styles.selectBtn}
              children={"Select All"}
              onClick={onSelectAll}
            />

            <Button
              className={styles.unselectBtn}
              children={"Unselect All"}
              onClick={onUnselectAll}
            />
          </div>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.modalContentScrollContainer}>
            {_diamonds && _diamonds.length > 0 ? (
              _diamonds.map((diamond) => (
                <div onClick={() => handleCheck(diamond.iboNumber)}>
                  <CheckBoxItem
                    name={`${diamond.iboNumber} - ${formatName(
                      diamond.fullName
                    )}`}
                    checked={diamond.isChecked}
                  />
                </div>
              ))
            ) : (
              <div className={styles.error}>No Diamonds Found</div>
            )}
          </div>
        </div>
        <div className={styles.submitRow}>
          <Button
            className={styles.submitBtn}
            children={"Sync"}
            onClick={handleSubmit}
          />
          <Button
            className={styles.cancelBtn}
            children={"Cancel"}
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
}
